import docready from "../libs/docready";

/**
 * @param container query result container with stub elements to replace
 * @param requestArgs for filling the stub
 */
const loadContent = function (container, requestArgs) {
    const args = structuredClone(requestArgs)
    const getItems = async function (page) {
        args.data.page = page
        const content = await $.get(args)
        if (content.items && content.items.length > 0 && container.find('.stub').length > 0) {
            content.items.forEach((item) => {
                const $item = $(item)
                container.find('.stub:first').replaceWith($item)
                docready($item)
            })
            return page + 1
        } else {
            throw 0;
        }
    }
    setTimeout(async () => {
        let page = 1
        container.addClass('loading')
        try {
            while(true) { // while promise is resolved.
                page = await getItems(page)
            }
        } catch (a) {
            // error has no meaning here.
            container.removeClass('loading')
        }
        return true
    })
}
export default context => {
    $('ul.ajax-loading-groups[data-type]', context).each(function () {
        loadContent(
            $(this),
            {
                url: '/site/communities/groups',
                data: {cid, type: $(this).data('type'), view: window.view || 'auto', gid: window.gid || 0},
            }
        )
    })

    $('.ajax-loading-people', context).each(function () {
        loadContent($(this), {url: '/site/subscriptions/public-list', data: {cid, gid}})
    })
}
